export default {
    SETTINGS: "Настройки",
    USERS: "Пользователи",
    ACTION_LOG: "Журнал действий",
    CONNECTIONS: "Подключения",
    ROLES: "Роли",
    TASK_STATISTICS: "Статистика задач",
    ONTOLOGICAL_MODEL: "Онтологическая модель",
    METHODS: "Методы",
    PASSWORD_POLICY: "Парольная политика",
    PANEL_ADMIN: "Панель администратора",
    BILLING: "Биллинг"
};
